import { SVGProps } from 'react';

export const CalendarDateRangeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width ?? '18'}
    height={props?.height ?? '18'}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.25 16.5C15.075 16.5 15.75 15.825 15.75 15V4.5C15.75 3.675 15.075 3 14.25 3H13.5V1.5H12V3H6V1.5H4.5V3H3.75C2.9175 3 2.2575 3.675 2.2575 4.5L2.25 15C2.25 15.825 2.9175 16.5 3.75 16.5H14.25ZM6.75 9.75V8.25H5.25V9.75H6.75ZM3.75 6H14.25V4.5H3.75V6ZM14.25 7.5V15H3.75V7.5H14.25ZM12.75 9.75V8.25H11.25V9.75H12.75ZM9.75 9.75H8.25V8.25H9.75V9.75Z"
      fill={props?.fill ?? '#217C74'}
    />
  </svg>
);

export default CalendarDateRangeIcon;
